/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PropertyMatrixConfigurationV2 {
  rootUrl: string = '';
}

/**
 * Parameters for `PropertyMatrixApiModuleV2.forRoot()`
 */
export interface PropertyMatrixConfigurationV2Params {
  rootUrl?: string;
}
